import { isDevelopment } from '@app/environment';
import { BaseGraphqlService } from '@core/services/base';
import { Inject, Injectable } from '@rxdi/core';
import { SocialService } from '@stradivario/graphql-server';
import { delay, filter, switchMap, take, tap } from 'rxjs/operators';

@Injectable({
  init: true,
})
export class OnlineStatusService extends BaseGraphqlService {
  @Inject(SocialService)
  private socialService: SocialService;

  OnInit() {
    // this.socialService.isLoggedIn
    //   .pipe(filter((i) => !!i))
    //   .pipe(
    //     take(1),
    //     delay(3000),
    //     switchMap(() => this.setOnlineStatus(true))
    //     // tap(
    //     //   () =>
    //     //     (window.onbeforeunload = async (e) => {
    //     //       e.preventDefault();
    //     //       firstValueFrom(this.setOnlineStatus(false));
    //     //       return undefined;
    //     //     })
    //     // )
    //   )
    //   .subscribe();
  }
  setOnlineStatus(active: boolean) {
    return this.mutate({
      mutation: 'set-online-status.graphql',
      variables: {
        active,
      },
    });
  }
}
